import React, { useState } from 'react'
import swal from 'sweetalert';
import Select from 'react-select';

export default function Addcompany(props) {
    const [items, setitems] = useState({ name: "", status: "" })
    const [status, setstatus] = useState([
        { value: 1, label: "Active" },
        { value: 2, label: "Inactive" },
    ])
    const [statusvalue, setstatusvalue] = useState();
    const handleInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setitems({ ...items, [name]: value })
    }
    const refresh = () => {
        setitems({ ...items, name: "", status: "" });
        setstatusvalue(null)
    }
    const savemethod = async (data) => {
        const url = process.env.REACT_APP_APIURL + "Company/AddCompany";
        await fetch(url, {
            method: "POST",
            headers: {
                'Accept': "json",
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then(res => {
            if (res.status == 200) {
                swal({
                    title: "Saved Successfully",
                    //  text: "Once deleted, you will not be able to recover this imaginary file!",
                    icon: "success"
                })
                refresh();
                
            }
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        savemethod(items);  
    }
    return (
        <div className="row">
            <div className="col-12 col-md-12">
                <div className="card">
                    <div className="card-header">
                        <h3 className="me-auto mb-2 mt-5 text-center mx-auto">Add Company</h3>
                    </div>
                    <div className="card-body">

                        <div className="basic-form">
                            <form action="" onSubmit={handleSubmit}>
                                <div className="row flex-column align-items-center">
                                    <div className="mb-3 col-sm-6">
                                        <label className="form-label">Name</label>
                                        <input type="text" autoComplete="off" className="form-control" name="name" value={items.name} onChange={handleInput} required />
                                    </div>
                                    <div className="mb-3 col-sm-6">
                                        <label className="form-label">Status</label>
                                        <Select options={status} value={statusvalue} onChange={(e) => { setstatusvalue(e); setitems({ ...items, status: e.value }) }} />
                                    </div>
                                </div>
                                <button type="submit" className="btn btn-primary">Save</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}